var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "step step-publication",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { staticClass: "step-row" }, [
        _c("div", { staticClass: "step-row__title text_xl_large" }, [
          _vm._v(_vm._s(_vm.i18n.sale_publication_text_1()))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "step-row__title text_medium" }, [
          _vm._v(_vm._s(_vm.i18n.sale_publication_text_2()))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "step-row__title text_medium" }, [
          _vm._v(_vm._s(_vm.i18n.sale_publication_text_3()))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap column" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { type: "submit", disabled: _vm.isPending }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.i18n.sale_publication_confirm()) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "simple-link arrow_back",
              on: {
                click: function($event) {
                  return _vm.stepBack()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_go_back_2()) + "\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61c01a1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c01a1b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/saleCreation/steps/Step.Publication.vue
// module id = qupL
// module chunks = 1